import React from "react"
import clsx from 'clsx'
import BedroomBuilderErrors from "../BedroomBuilderErrors"
//import I18n from "i18n-js/index.js.erb"
import NumberSpinner from "../../NumberSpinner/NumberSpinner"

class BedroomBuilderGeneral extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'general',
      'tab-pane': true
    });

    return (
      <div className={tabClasses} id="general">
        {this.renderErrors()}
        <div className="row">
          <div className="col-md-12">
            {this.renderGeneralForm()}
          </div>
        </div>
      </div>
    )
  }

  renderErrors() {
    var errors = BedroomBuilderErrors.general(this.props.errors);

    if (errors && errors.length) {
      var idx = 0;
      var errors = errors.map((error) => {
        idx = idx + 1;
        return <li key={error + idx}>{error}</li>
      });

      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      );
    }
  }

  renderFieldErrors(field) {
    if (this.props.errors && this.props.errors[field]) {
      var idx = 0;
      var errors = this.props.errors[field].map((error) => {
        idx = idx + 1;
        return <li key={idx}><b>&#x2022;</b> {error}</li>;
      });
      return (
        <div className="help-block">
          <ul>{errors}</ul>
        </div>
      )
    }
  }

  renderFieldClasses(field, noFormControl) {
    if (noFormControl === true) {
      var classname = ''
    } else {
      var classname = 'form-control';
    }
    if (this.props.errors && Object.keys(this.props.errors).length && this.props.errors[field]) {
      classname = classname + ' has-errors';
    }
    return classname;
  }

  renderGeneralForm() {
    return (
      <div>
        <div className="row" id="test">
          <div className="col-md-3">
            <div className="form-group">
              <label>{`${I18n.t('code')}*`}</label>
              <input
                id="code"
                type="text"
                name="bedroom[code]"
                maxLength="12"
                className={this.renderFieldClasses('code')}
                value={this.props.code || ''}
                onChange={this.props.onFieldChange} />
              {this.renderFieldErrors("code")}
            </div>
          </div>

          <div className="col-md-6" >
            <div className="form-group">
              <label>{`${I18n.t('name')}*`}</label>
              <input
                id="name"
                type="text"
                name="bedroom[name]"
                className={this.renderFieldClasses('name')}
                value={this.props.name || ''}
                onChange={this.props.onFieldChange} />
              {this.renderFieldErrors("name")}
            </div>
          </div>
        </div>

        <hr />
        <div className="row">
          <div className="col-md-3">
            <div className="form-group">
              <label>
                {I18n.t('room_size')} <span className="ss-help help" title={I18n.t('room_size_helper_text')}></span>
              </label>
              <input
                id="room_size"
                type="text"
                name="bedroom[room_size]"
                value={this.props.room_size || ''}
                onChange={this.props.onFieldChange}
                className="form-control"
                placeholder={I18n.t('eg_room_size')} />
            </div>
          </div>


          <div className="col-md-3" >
            <div className="form-group">
              <label>
                {I18n.t('bed_type')} <span className="ss-help help" title={I18n.t('bed_type_helper_text')}></span>
              </label>
              <input
                id="bed_type"
                type="text"
                name="bedroom[bed_type]"
                value={this.props.bed_type || ''}
                onChange={this.props.onFieldChange}
                className="form-control"
                placeholder={I18n.t('eg_bed_type')} />
            </div>
          </div>

          <div className="col-md-3">
            <div className="form-group">
              <label>{I18n.t("composition")}*</label>
              <select
                name="composition_room_id"
                value={this.props.composition_room_id || ""}
                className={this.renderFieldClasses("composition_room")}
                onChange={this.props.onChangeCompositionRoom}
              >
                <option value="">{I18n.t("please_select_one")}</option>
                {this.props.all_composition_rooms.map((composition_room) => {
                  return (
                    <option key={composition_room.id} value={composition_room.id}>
                      {composition_room.description}
                    </option>
                  );
                })}
              </select>
              {this.renderFieldErrors("composition_room")}
            </div>
          </div>



        </div>



        <hr />
        <div className="row" id="test2">
          <div className="col-md-9">
            <div className="form-group">
              <label>{I18n.t('description')}</label>
              <textarea name="bedroom[description]" id="description" className="form-control" rows={7} value={this.props.description || ''} onChange={this.props.onFieldChange} />
            </div>
          </div>
        </div>
      </div>
    )
  }

}

export default BedroomBuilderGeneral
